type Props = {
    onLabel: React.ReactNode;
    offLabel: React.ReactNode;
    onChange?(state: boolean): void;
    className?: string;
    value: boolean;
};

const SelectAllToggle = ({
    value,
    onLabel,
    offLabel,
    onChange,
    className,
}: Props) => {
    return (
        <div className={className} onClick={() => onChange && onChange(!value)}>
            {value ? onLabel : offLabel}
        </div>
    );
};

export default SelectAllToggle;
